export function SearchField({
  value,
  onChange,
  placeholder,
  className = '',
  ariaLabel,
}: {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  className?: string;
  ariaLabel?: string;
}) {
  return (
    <div className={`relative flex-1 min-w-[200px] ${className}`}>
      <input
        className="input-base w-full pr-9"
        type="search"
        placeholder={placeholder}
        value={value}
        aria-label={ariaLabel ?? placeholder ?? 'Search'}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 grid h-6 w-6 place-items-center
                     rounded-sm text-parchment-100/50 hover:text-gold-300 hover:bg-ink-700/60
                     transition-colors"
        >
          ✕
        </button>
      )}
    </div>
  );
}
